import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { COURSES_API } from '../api/courses-api'
import { ReminderEmailInterface, ReminderInterface } from '../types/reminder-interface'

interface Props {
  courseId: number
  isReminderFetchAllowed: boolean
  isReminderEmailFetchAllowed: boolean
}

export const useReminder = ({
  courseId,
  isReminderFetchAllowed,
  isReminderEmailFetchAllowed,
}: Props) => {
  const { fetcher: reminderSettingsFetcher } = useFetch<RequestMethodsEnum.get, ReminderInterface>({
    method: RequestMethodsEnum.get,
  })

  const { fetcher: reminderEmailFetcher } = useFetch<
    RequestMethodsEnum.get,
    ReminderEmailInterface
  >({
    method: RequestMethodsEnum.get,
  })

  const {
    data: reminderData,
    isLoading: isReminderDataLoading,
    mutate: mutateReminderData,
  } = useControlledSwr(
    () => `${COURSES_API}/${courseId}/reminder-settings`,
    reminderSettingsFetcher,
    undefined,
    isReminderFetchAllowed,
  )

  const {
    data: reminderEmailData,
    isLoading: isReminderEmailSettingsLoading,
    mutate: mutateReminderEmailData,
  } = useControlledSwr(
    () => `${COURSES_API}/${courseId}/reminder-settings/email`,
    reminderEmailFetcher,
    undefined,
    isReminderEmailFetchAllowed,
  )

  return {
    reminderData,
    reminderEmailData,
    isReminderDataLoading,
    isReminderEmailSettingsLoading,
    mutateReminderEmailData,
    mutateReminderData,
  }
}
